/**
 * 隐私条款内容数据
 * 结构化维护，方便后续修订或多语言
 */
export const PRIVACY_META = {
  title: '隐私政策',
  updated: '2026-01-01',
  contact: '82131529@qq.com',
};

export const PRIVACY_SECTIONS = [
  {
    id: 'intro',
    heading: '引言',
    paragraphs: [
      '书阁园系列应用（包括但不限于 LYZNote、LYZDownload 等，以下统称"本应用"）由书阁园团队（以下简称"我们"）开发与维护。我们深知个人信息对您的重要性，并将依据相关法律法规，本着合法、正当、必要、诚信的原则保护您的个人信息。',
      '本隐私政策旨在向您说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您就这些信息所享有的权利。请您在使用本应用前仔细阅读并充分理解本政策。',
    ],
  },
  {
    id: 'collected',
    heading: '我们收集的信息',
    paragraphs: ['我们仅收集为实现产品功能所必需的最少信息，具体包括：'],
    list: [
      { label: '账号信息', desc: '若您注册账号，我们会收集您的邮箱地址、昵称、加密后的登录凭证。' },
      { label: '设备信息', desc: '包括设备型号、操作系统版本、屏幕分辨率、设备标识符（用于崩溃统计与多端同步）。' },
      { label: '使用数据', desc: '匿名化的功能使用事件、页面停留时长，用于产品改进；不会与您的身份关联。' },
      { label: '笔记/文档内容', desc: '您在使用本应用过程中创建、上传的文本、图片、附件等，仅存储于您选择的账户空间或本地设备。' },
    ],
  },
  {
    id: 'purpose',
    heading: '信息的使用目的',
    list: [
      '提供、维护和改进本应用的核心功能与服务；',
      '实现跨设备的数据同步与备份；',
      '在获得您明确授权时，用于身份验证与安全风控；',
      '响应您的客服请求、处理投诉与纠纷；',
      '在符合法律法规要求的前提下，配合监管机关的合法要求。',
    ],
  },
  {
    id: 'storage',
    heading: '信息存储与保护',
    paragraphs: [
      '我们采用行业标准的安全措施保护您的数据，包括 <strong>TLS/HTTPS 传输加密</strong>、<strong>AES-256 存储加密</strong>、访问控制与最小权限原则等。',
      '您可在应用设置中随时导出或清除云端数据。除非法律法规另有规定，我们对您的个人信息存储期限仅限于实现本政策所述目的所必需的最短时间。',
    ],
  },
  {
    id: 'sharing',
    heading: '信息共享与披露',
    paragraphs: ['除以下情形外，我们不会将您的个人信息与第三方共享：'],
    list: [
      '事先获得您的明确同意或授权；',
      '为实现核心功能所必需的服务商（如同步、支付）协助处理，且已签署数据处理协议；',
      '根据法律法规、行政或司法机关的强制性要求；',
      '在涉及合并、收购或破产清算时，我们会要求新的持有方继续受本政策约束，否则将重新征得您的同意。',
    ],
  },
  {
    id: 'rights',
    heading: '您的权利',
    paragraphs: ['依据适用法律，您有权：'],
    list: [
      '访问、复制您的个人信息；',
      '更正、补充不准确的信息；',
      '删除您的个人信息或注销账号；',
      '撤回已给予的同意（撤回不影响撤回前基于同意已进行的处理）；',
      '获取个人信息副本的可携带权。',
    ],
    paragraphsAfter: [
      `如需行使上述权利，请通过 ${'本页面底部的联系方式'} 与我们联系。我们将在 15 个工作日内响应。`,
    ],
  },
  {
    id: 'cookies',
    heading: 'Cookie 与同类技术',
    paragraphs: [
      '本应用网站可能使用 Cookie 或类似技术以维持登录状态、记录偏好、分析访问情况。您可通过浏览器设置拒绝 Cookie，但可能影响部分功能的正常使用。',
    ],
  },
  {
    id: 'children',
    heading: '未成年人保护',
    paragraphs: [
      '本应用主要面向成年人。若您为未满 14 周岁的未成年人，请在父母或监护人的陪同和同意下使用本应用并向我们提供个人信息。',
    ],
  },
  {
    id: 'changes',
    heading: '本政策的更新',
    paragraphs: [
      '我们可能适时修订本政策内容。若发生重大变更，我们会在应用内或网站显著位置另行通知。若您继续使用本应用，即视为您接受修订后的政策。',
    ],
  },
  {
    id: 'contact',
    heading: '联系我们',
    paragraphs: [
      '如您对本隐私政策有任何疑问、意见或建议，可通过以下方式与我们联系：',
    ],
    list: [
      { label: '作者微信', desc: 'zhenzi0322（公众号：书阁园）' },
      { label: '邮箱', desc: '82131529@qq.com' },
      { label: '反馈渠道', desc: '应用内 "设置 → 帮助与反馈"' },
    ],
  },
];
